import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const eContractAgreementSerializeMap: SerializeMap<EContractAgreement> = {
  buyerBusinessId: "buyer_business_id",
  created: "created",
  deploymentSaleId: "deployment_sale_id",
  econtractIds: "econtract_ids",
  id: "id",
  permissions: "permissions",
  specialConditionIds: "special_condition_ids",
  vendorBusinessId: "vendor_business_id",
};

export const serializeEContractAgreement = buildSerializer(
  eContractAgreementSerializeMap,
  "eContractAgreement",
);
export const deserializeEContractAgreement = buildDeserializer(
  eContractAgreementSerializeMap,
  "eContractAgreement",
);
